module.exports = __webpack_public_path__ + "static/img/aqzs21.c040ab36.jpg";